import React from "react"
import * as styles from "./Styles/Help.module.scss"
import Icon from "../Utils/Icon"

const Help: React.FC = () => (
  <div className="l-section-background--admin">
    <h2>手順書</h2>
    <div>
      <div className={styles.helps}>
        <div>
          <Link
            anchorText="混雑ランプ スマートフォン"
            url="https://locoguide.jp/static/uploads/lamp_manual_sp.pdf"
          />
        </div>
        <div>
          <Link
            anchorText="混雑ランプ PC"
            url="https://locoguide.jp/static/uploads/lamp_manual_pc.pdf"
          />
        </div>
        <div>
          <Link
            anchorText="混雑ランプ ボタン"
            url="https://locoguide.jp/static/uploads/lamp_manual_button.pdf"
          />
        </div>
      </div>
    </div>
  </div>
)

const Link = ({ url, anchorText }) => (
  <a href={url} target="_blank">
    {anchorText}
    <Icon
      className={styles.icon}
      type="feather"
      name="external-link"
      attr={{ width: 14, height: 14 }}
    />
  </a>
)
export default Help
